import { atom } from "recoil";
import { OfficeAccountType } from "../types";
export const addStateOfficeAccount = atom({
  key: "addStateOfficeAccount",
  default: false,
});
export const editStateOfficeAccount = atom({
  key: "editStateOfficeAccount",
  default: false,
});
export const rowEditOfficeAccount = atom<OfficeAccountType | undefined>({
  key: "rowEditOfficeAccount",
  default: undefined,
});

export const selectedRowsStateOfficeAccount = atom<OfficeAccountType[]>({
  key: "selectedRowsStateOfficeAccount",
  default: [],
});

export const officeAccountFilterText = atom({
  key: "officeAccountFilterText",
  default: "",
});

export const savingOfficeAccount = atom({
  key: "savingOfficeAccount",
  default: false,
});
export const officeAccountFetching = atom({
  key: "officeAccountFetching",
  default: true,
});
export const officeAccountReFetching = atom({
  key: "officeAccountFetching",
  default: true,
});

